module.exports = __webpack_public_path__ + "static/media/music_dis.11d2f0f6.svg";